export enum PaymentOverallStatus {
    FULLY_PAID = 'FULLY_PAID',
    NOT_PAID = 'NOT_PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID'
}

export enum PaymentStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    UNKNOWN = 'UNKNOWN'
}